// @flow
import type {
  AuthState,
} from '../types'

export default ({
  token: null,
  user: null,
  isAuthenticated: false,
  isAuthenticating: false,
  isBooting: false,
  errors: [],
}: AuthState)
